import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Lottie from 'react-lottie';
import PublishInstructionsText from './PublishInstructionsText.jsx';
import PublishButtonAndTooltip from './PublishButtonAndTooltip.jsx';
import s from './PublishInstructions.module.scss';

const PublishInstructions = ({ animationOptions, handlePublishClick, isVisible, publishPending, status, stopDate, hasAssetsWritePermission, publishFrozen }) => {
    if (publishFrozen) {
        return (
            <div className={classNames(s.instructions, s.frozen)}>
                <div className={s.unavailable} data-testid="publish-unavailable">
                    Publishing is currently unavailable. For questions or support, contact content@atrius.com
                </div>
            </div>
        );
    }

    return (
        <div className={s.instructions}>
            <div className={s.textAndButton}>
                <PublishInstructionsText />
                <PublishButtonAndTooltip
                    handlePublishClick={handlePublishClick}
                    hasAssetsWritePermission={hasAssetsWritePermission}
                    isVisible={isVisible}
                    publishPending={publishPending}
                    status={status}
                    stopDate={stopDate}
                />
            </div>
            <div>
                <Lottie options={animationOptions} height={430} width={300} isStopped={status !== 'RUNNING'} isPaused={false} />
            </div>
        </div>
    );
};

PublishInstructions.propTypes = {
    animationOptions: PropTypes.object.isRequired,
    handlePublishClick: PropTypes.func.isRequired,
    hasAssetsWritePermission: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    publishPending: PropTypes.bool.isRequired,
    status: PropTypes.string.isRequired,
    stopDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]).isRequired,
    publishFrozen: PropTypes.bool,
};

PublishInstructions.defaultProps = {
    publishFrozen: false,
};

export default PublishInstructions;
